import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.css']
})
export class ModuloComponent extends GeneralExerciseComponent {

  message: string;
  dimension: number[] = [0, 0];

  c: number[] = [];
  messageArray: number[][] = [];
  formula: string[] = [];
  formulaFilled: string[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.message = this.configuration.typespecifics.message;
    this.dimension = this.configuration.typespecifics.dimension;
    this.c = [];

    this.formula = [];
    this.formulaFilled = []

    this.messageArray = [];
    if (this.message != undefined) {
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        this.messageArray.push(elem);
      }
    }

  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.c) {
        this.c = this.state.typespecific.c;
      }
      if (this.state.typespecific.formula) {
        this.formula = this.state.typespecific.formula;
      }

      if (this.state.typespecific.formulaFilled) {
        this.formulaFilled = this.state.typespecific.formulaFilled;
      }
    }
  }

  computeState() {
    this.state.typespecific.c = this.c;
    this.state.typespecific.formula = this.formula;
    this.state.typespecific.formulaFilled = this.formulaFilled;
  }

  checkSolution() {
    //check the formulas
    let solutionFormula = [];
    let error = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      error.push(false);
    }

    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[i] = [];
      let index = i;
      while (index < this.dimension[0] * this.dimension[1]) {
        solutionFormula[i].push(index);
        index += this.dimension[1]
      }
    }


    for (let i = 0; i < this.dimension[0]; i++) {
      solutionFormula[i + this.dimension[1]] = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        solutionFormula[i + this.dimension[1]].push(i * this.dimension[1] + j);
      }
    }

    for (let i = 0; i < this.dimension[1] + this.dimension[0]; i++) {
      if (!this.formula[i]) {
        error[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕");
      for (let p of solutionFormula[i]) {
        if (!allParts.includes("a".concat((p + 1).toString()))) {
          error[i] = true;
        }
      }
    }

    if (!this.formula[this.dimension[1] + this.dimension[0]]) {
      error[this.dimension[1] + this.dimension[0]] = true;
    } else {

      let allParts = this.formula[this.dimension[1] + this.dimension[0]].split(" ").filter(v => v != "⊕");
      let error1 = false;
      let error2 = false;
      for (let i = 0; i < this.dimension[1]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error1 = true;
        }
      }

      for (let i = this.dimension[1]; i < this.dimension[1] + this.dimension[0]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error2 = true;
        }
      }

      error[this.dimension[1] + this.dimension[0]] = error1 && error2;
    }

    if (error.filter(v => v).length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      return;
    }

    if (this.message == "" || this.message == undefined) {
      this.solved = true;
      this.state.solved = true;
      this.saveState();
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      return;
    }

    //check the applied formulas
    let messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      messageArray.push(elem);
    }
    let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);

    error.fill(false);
    for (let i = 0; i < this.dimension[1] + this.dimension[0] + 1; i++) {
      if (!this.formulaFilled[i]) {
        error[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕").map(v => v.replace(/[^0-9]/gi, ""));
      let solution = [];
      for (let p of allParts) {
        solution.push(this.message.split("")[+p - 1]);
      }

      if (i == this.dimension[0] + this.dimension[1]) {
        solution = [];
        for (let p of allParts) {
          solution.push(correctc[+p - 1]);
        }
      }

      if (this.formulaFilled[i].trim() != solution.join(" ⊕ ")) {
        error[i] = true;
      }
    }

    if (error.filter(v => v).length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInFormulaFilled").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      return;
    }

    let errorC = correctc.map((v, i) => [v, i]).filter(v => v[0] != this.c[v[1]]).map(v => 'c'.concat((v[1]+1).toString()));

    if (errorC.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInC").concat(": ", errorC.join(", ")), "danger", 10000);
      return;
    }

    this.solved = true;
    this.state.solved = true;
    this.saveState();
    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
  }

  evaluate(): number[] {
    let result = [0, 1]
    //check the formulas
    let solutionFormula = [];
    let error = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      error.push(false);
    }

    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[i] = [];
      let index = i;
      while (index < this.dimension[0] * this.dimension[1]) {
        solutionFormula[i].push(index);
        index += this.dimension[1]
      }
    }


    for (let i = 0; i < this.dimension[0]; i++) {
      solutionFormula[i + this.dimension[1]] = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        solutionFormula[i + this.dimension[1]].push(i * this.dimension[1] + j);
      }
    }

    for (let i = 0; i < this.dimension[1] + this.dimension[0]; i++) {
      if (!this.formula[i]) {
        error[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕");
      for (let p of solutionFormula[i]) {
        if (!allParts.includes("a".concat((p + 1).toString()))) {
          error[i] = true;
        }
      }
    }

    if (!this.formula[this.dimension[1] + this.dimension[0]]) {
      error[this.dimension[1] + this.dimension[0]] = true;
    } else {

      let allParts = this.formula[this.dimension[1] + this.dimension[0]].split(" ").filter(v => v != "⊕");
      let error1 = false;
      let error2 = false;
      for (let i = 0; i < this.dimension[1]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error1 = true;
        }
      }

      for (let i = this.dimension[1]; i < this.dimension[1] + this.dimension[0]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error2 = true;
        }
      }

      error[this.dimension[1] + this.dimension[0]] = error1 && error2;
    }

    result = [((this.dimension[1] + this.dimension[0] + 1) - error.filter(v => v).length) * 0.5, (this.dimension[1] + this.dimension[0] + 1) * 0.5]

    if (this.message == "" || this.message == undefined) {
      return result;
    }

    //check the applied formulas
    let messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      messageArray.push(elem);
    }
    let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);

    let errorF = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      errorF.push(false);
    }
    for (let i = 0; i < this.dimension[1] + this.dimension[0] + 1; i++) {
      if (!this.formulaFilled[i] || error[i]) {
        errorF[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕").map(v => v.replace(/[^0-9]/gi, ""));
      let solution = [];
      for (let p of allParts) {
        solution.push(this.message.split("")[+p - 1]);
      }

      if (i == this.dimension[0] + this.dimension[1]) {
        solution = [];
        for (let p of allParts) {
          solution.push(correctc[+p - 1]);
        }
      }

      if (this.formulaFilled[i].trim() != solution.join(" ⊕ ")) {
        errorF[i] = true;
      }
    }

    let errorC = correctc.map((v, i) => [v, i]).filter((v, i) => (v[0] != this.c[v[1]]) || errorF[i]).map(v => v[1]);


    result = [result[0] + (this.dimension[0] + this.dimension[1] + 1 - errorC.length) * 0.5, result[1] + (this.dimension[0] + this.dimension[1] + 1) * 0.5]
    console.log(result);
    return result;
  }

  /** normalizes the formulas */
  normalizeFormula(i: number) {
    if (this.formula[i]) {
      this.formula[i] = this.formula[i].replace(/[+]/gi, " ⊕ ").replace(/\s+/gi, " ").replace(/[^0-9⊕ac ]/gi, "");
    }
  }

  /** normalizes the filled formulas */
  normalizeFormulaFilled(i: number) {
    if (this.formulaFilled[i]) {
      this.formulaFilled[i] = this.formulaFilled[i].replace(/[+]/gi, " ⊕ ").replace(/[^0-9⊕ ]/gi, "");
    }
  }

  /** normalizes the control bits */
  normalize(s: any): string {
    if (s == undefined) {
      return "";
    }
    return s.toString().replace(/[^01]/, "");
  }

  /** if enough is correctly solve, solve the rest of the exericse */
  autoFill() {
    let filled = 0;
    //compute the filled lines
    let filledLines: number[] = [];

    filledLines = this.formula.map((v, i) => [v, i]).filter(v => v[0] != "" && v[0] != undefined).map(v => +v[1]);
    filledLines = filledLines.concat(this.formulaFilled.map((v, i) => [v, i]).filter(v => v[0] != "" && v[0] != undefined).map(v => +v[1]));
    filledLines = filledLines.concat(this.c.map((v, i) => [v, i]).filter(v => v[0] != undefined).map(v => v[1]));
    filledLines = filledLines.filter((v, i) => filledLines.indexOf(v) == i)

    filled = filledLines.length / (this.dimension[0] + this.dimension[1] + 1);

    if (filled < 0.3) {
      this.messageService.addAlertWithTimeout(this.get("solveMore"), "info", 10000);
      return;
    }



    //check the formulas
    let solutionFormula = [];
    let error = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      error.push(false);
    }

    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[i] = [];
      let index = i;
      while (index < this.dimension[0] * this.dimension[1]) {
        solutionFormula[i].push(index);
        index += this.dimension[1]
      }
    }


    for (let i = 0; i < this.dimension[0]; i++) {
      solutionFormula[i + this.dimension[1]] = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        solutionFormula[i + this.dimension[1]].push(i * this.dimension[1] + j);
      }
    }

    for (let i = 0; i < this.dimension[1] + this.dimension[0]; i++) {
      if (filledLines.includes(i)) {
        if (!this.formula[i]) {
          error[i] = true;
          continue;
        }
        let allParts = this.formula[i].split(" ").filter(v => v != "⊕");
        for (let p of solutionFormula[i]) {
          if (!allParts.includes("a".concat((p + 1).toString())) && filledLines.includes(i)) {
            error[i] = true;
          }
        }
      }
    }

    if (!this.formula[this.dimension[1] + this.dimension[0]] && filledLines.includes(this.dimension[1] + this.dimension[0])) {
      error[this.dimension[1] + this.dimension[0]] = true;
    } else if (filledLines.includes(this.dimension[1] + this.dimension[0])) {
      let allParts = this.formula[this.dimension[1] + this.dimension[0]].split(" ").filter(v => v != "⊕");
      let error1 = false;
      let error2 = false;
      for (let i = 0; i < this.dimension[1]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error1 = true;
        }
        solutionFormula[this.dimension[0] + this.dimension[1]].push(i);
      }

      for (let i = this.dimension[1]; i < this.dimension[1] + this.dimension[0]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error2 = true;
        }
      }

      error[this.dimension[1] + this.dimension[0]] = error1 && error2;
    }


    solutionFormula[this.dimension[0] + this.dimension[1]] = [];
    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[this.dimension[0] + this.dimension[1]].push(i);
    }

    if (this.message == "" || this.message == undefined) {
      if (error.filter(v => v).length > 0) {
        this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
        this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
        return;
      }

      for (let i = 0; i < solutionFormula.length; i++) {
        if (!filledLines.includes(i)) {
          this.formula[i] = solutionFormula[i].map(v => "a".concat((v + 1).toString())).join(" ⊕ ");
          if (i == this.dimension[0] + this.dimension[1]) {
            this.formula[i] = solutionFormula[i].map(v => "c".concat((v + 1).toString())).join(" ⊕ ");
          }
        }
      }

      return;

    }

    //check the applied formulas
    let messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      messageArray.push(elem);
    }
    let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);

    let errorF = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      errorF.push(false);
    }
    let solution = [];
    for (let i = 0; i < this.dimension[1] + this.dimension[0] + 1; i++) {
      solution[i] = [];
        if ((!this.formulaFilled[i] || error[i]) && filledLines.includes(i) ) {
          errorF[i] = true;
          continue;
        }
        let allParts = [];
        if(filledLines.includes(i)){
          allParts = this.formula[i].split(" ").filter(v => v != "⊕").map(v => v.replace(/[^0-9]/gi, ""));
        } else {
          allParts = solutionFormula[i].map(v => v+1);
        }
        
        for (let p of allParts) {
          solution[i].push(this.message.split("")[+p - 1]);
        }

        if (i == this.dimension[0] + this.dimension[1]) {
          solution[i] = [];
          for (let p of allParts) {
            solution[i].push(correctc[+p - 1]);
          }
        }
        if (filledLines.includes(i) && this.formulaFilled[i].trim() != solution[i].join(" ⊕ ")) {
          errorF[i] = true;
        }
      
    }

    let errorC = correctc.map((v, i) => [v, i]).filter((v, i) => ((v[0] != this.c[v[1]]) || errorF[i])&& filledLines.includes(i)).map(v => v[1]);

    if(errorC.length > 0){
      this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
      if (error.filter(v => v).length > 0) {
        this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      } else if(errorF.filter(v => v).length > 0){
        this.messageService.addAlertWithTimeout(this.get("errorInFormulaFilled").concat(": ", errorF.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("errorInC").concat(": ", errorC.map(v => v + 1).join(", ")), "danger", 10000);
      }
      return;
    }

    for (let i = 0; i < solution.length; i++) {
      if (!filledLines.includes(i)) {
        this.formula[i] = solutionFormula[i].map(v => "a".concat((v + 1).toString())).join(" ⊕ ");
          if (i == this.dimension[0] + this.dimension[1]) {
            this.formula[i] = solutionFormula[i].map(v => "c".concat((v + 1).toString())).join(" ⊕ ");
          }
        this.formulaFilled[i] = solution[i].join(" ⊕ ");
        this.c[i] = correctc[i];
      }
    }

    return;

  }

}
